import { ConnectComponent } from '../_components/ConnectComponent'
import { SummaryPresenter } from './Summary.presenter'
import { SummaryView } from './Summary.view'

export const Summary = ConnectComponent(SummaryView, SummaryPresenter)
